var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiSlider, UiIncremental } from '@claims-ia/design-system';
import { SURFACE_DAMAGE_VETUSTY_CHOICES } from '@shared/constants/roomDamageConstants';
import { COVERING_PLACEHOLDER_TRADKEYS } from '@declaration/constants/roomDamageConstants';
import { surfaceDamageOfType } from '@shared/roomDamage/surfaceDamage';
import { optionalResourceIri } from '@shared/utils/iri';
import { objectToTranslatableChoices } from '@shared/choice';
const roomDamage = namespace('roomDamage');
const settings = namespace('settings');
let SurfaceDamagesInput = class SurfaceDamagesInput extends Vue {
    constructor() {
        super(...arguments);
        this.defaultVetustyChoices = SURFACE_DAMAGE_VETUSTY_CHOICES;
        this.optionalResourceIri = optionalResourceIri;
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get roomDamage() {
        return this.change.data;
    }
    get surfaceDamages() {
        if (!this.roomDamage.surfaceDamages) {
            return [];
        }
        return this.roomDamage.surfaceDamages.filter(surfaceDamageOfType(this.surfaceType));
    }
    get isObsolescenceEnabled() {
        return this.setting('obsolescenceEnabled') === 'true';
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get vetustyChoices() {
        var _a, _b, _c;
        let vetustyChoices = this.defaultVetustyChoices;
        // si on a des choix personnalisés dans les settings de l'assureur
        const frontendSettings = this.setting('selfCareSettings');
        const customChoices = (_c = (_b = (_a = frontendSettings === null || frontendSettings === void 0 ? void 0 : frontendSettings.declaration) === null || _a === void 0 ? void 0 : _a.pages) === null || _b === void 0 ? void 0 : _b.roomDamagesContents) === null || _c === void 0 ? void 0 : _c.surfaceDamageVetustyChoices;
        if (customChoices && Array.isArray(customChoices)) {
            const choicesObject = customChoices.reduce((acc, choice) => {
                acc[choice.value.toString()] = choice.tradKey;
                return acc;
            }, {});
            vetustyChoices = objectToTranslatableChoices(choicesObject);
        }
        return vetustyChoices;
    }
    get surfaceDamageAge() {
        var _a;
        return Number((_a = this.surfaceDamages[0]) === null || _a === void 0 ? void 0 : _a.age) || 15;
    }
    set surfaceDamageAge(value) {
        this.setSurfaceDamageAges({
            age: value,
            changeKey: this.changeKey,
            surfaceType: this.surfaceType,
        });
    }
    get vetustySliderChoices() {
        // Calcul des segments du slider en fonction des choix disponibles
        const segmentValue = (index) => {
            const values = this.vetustyChoices
                .map((choice) => choice.value)
                .filter((value) => value !== null)
                .sort((a, b) => a - b);
            const currentValue = values[index];
            const previousValue = index === 0 ? 0 : values[index - 1];
            const segmentLength = currentValue - previousValue;
            const totalLength = Math.max(...values);
            return segmentLength / totalLength;
        };
        // Choices requis pour le slider du design system
        return this.vetustyChoices.map((choice, index) => ({
            label: this.$tc(choice.tradKey),
            value: Number(choice.value),
            segment: segmentValue(index),
        }));
    }
    surfaceDamageFieldName(surfaceIndex, field) {
        var _a;
        const allSurfaces = ((_a = this.roomDamage.surfaceDamages) !== null && _a !== void 0 ? _a : []);
        const damageIndex = allSurfaces.indexOf(this.surfaceDamages[surfaceIndex]);
        return `surfaceDamages.${damageIndex}.${field}`;
    }
    getSurfaceCoveringPlaceholder(surfaceIndex) {
        return this.$tc(COVERING_PLACEHOLDER_TRADKEYS[this.surfaceType], 0, {
            number: surfaceIndex + 1,
        });
    }
    surfaceDamageValidationErrors(index, field) {
        return this.validation.fieldErrors(this.surfaceDamageFieldName(index, field), this);
    }
    changeNumberOfSurfaceDamages(number) {
        if (number < this.surfaceDamages.length) {
            this.popSurfaceDamage({
                surfaceType: this.surfaceType,
                changeKey: this.changeKey,
            });
        }
        else {
            this.addNewSurfaceDamage({
                surfaceType: this.surfaceType,
                changeKey: this.changeKey,
                isObsolescenceEnabled: this.isObsolescenceEnabled,
            });
        }
    }
    switchHasSurfaceDamages(hasSurfaceDamages) {
        if (hasSurfaceDamages) {
            this.addNewSurfaceDamage({
                surfaceType: this.surfaceType,
                changeKey: this.changeKey,
                isObsolescenceEnabled: this.isObsolescenceEnabled,
            });
        }
        else {
            this.resetSurfaceDamage({
                surfaceType: this.surfaceType,
                changeKey: this.changeKey,
            });
        }
    }
};
__decorate([
    roomDamage.State('coveringCategoriesBySurfaceType')
], SurfaceDamagesInput.prototype, "coveringCategoriesBySurfaceType", void 0);
__decorate([
    roomDamage.Getter('change')
], SurfaceDamagesInput.prototype, "changeGetter", void 0);
__decorate([
    roomDamage.Getter('validation')
], SurfaceDamagesInput.prototype, "validationGetter", void 0);
__decorate([
    roomDamage.Action('resetSurfaceDamage')
], SurfaceDamagesInput.prototype, "resetSurfaceDamage", void 0);
__decorate([
    roomDamage.Action('addNewSurfaceDamage')
], SurfaceDamagesInput.prototype, "addNewSurfaceDamage", void 0);
__decorate([
    roomDamage.Action('popSurfaceDamage')
], SurfaceDamagesInput.prototype, "popSurfaceDamage", void 0);
__decorate([
    roomDamage.Action('setSurfaceDamageCovering')
], SurfaceDamagesInput.prototype, "setSurfaceDamageCovering", void 0);
__decorate([
    roomDamage.Action('setSurfaceDamageAges')
], SurfaceDamagesInput.prototype, "setSurfaceDamageAges", void 0);
__decorate([
    settings.Getter('setting')
], SurfaceDamagesInput.prototype, "setting", void 0);
SurfaceDamagesInput = __decorate([
    Component({
        components: {
            UiSlider,
            UiIncremental,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            surfaceType: {
                type: String,
                required: true,
            },
            canHaveMultipleSurface: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                required: true,
            },
        },
    })
], SurfaceDamagesInput);
export default SurfaceDamagesInput;
